import React, {useState, useContext} from 'react';
import Modal from "./Modal";
import EmailValidation from "./SignUpInformation/components/EmailValidation";
import ModalEncourageSignup from "../components2/encourageSignup/EncourageSignup";
import {useQueryClient} from "@tanstack/react-query";
import { ModalContext } from '../components2/ModalManager';
import {USER_CURRENT_CLICK_CTA_KEY, USER_CURRENT_KEY} from "../../api/public-voissa/users";
import _ from "lodash";
import { useNavigate} from "react-router-dom";


const CtaCannot = ({
        children = null,
        isModal = false,
        action = "",
        openModal = () =>{},
        disabled = false
    }) =>{
        const { openModal : openGlobalModal } = useContext(ModalContext);
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const [togglePopup, setTogglePopup] = useState(false);

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    const clickCta = queryClient.getQueryData([USER_CURRENT_CLICK_CTA_KEY]);


    function _openModal(){
        if(!disabled){
            if(!togglePopup) setTogglePopup(true);
            openModal();
        }
    }

    let modal = clickCta && clickCta[action];

    return (
        clickCta && modal && isCurrentUser ? (
            isModal && modal &&  modal.modal ? (
                <>
                    <div onClick={() => _openModal()}>
                        {children}
                    </div>
                    {modal === EmailValidation ? <EmailValidation toggle={togglePopup} handleClose={() => setTogglePopup(false)} /> : (
                        <Modal toggle={togglePopup} handleClose={() => setTogglePopup(false)}>
                            <modal.modal username={dataCurrentUser.username} userId={dataCurrentUser._id} handleClose={() => setTogglePopup(false)} />
                        </Modal>
                    )}
                </>
            ) : (
                <div onClick={() => modal.to ? navigate(modal.to) : null}>
                    {children}
                </div>
            )
        ) : (
            <>
                <div onClick={() => openGlobalModal('EncourageSignup')}>
                    {children}
                </div>
                <ModalEncourageSignup
                    toggle={togglePopup}
                    handleClose={() => setTogglePopup(false) }
                />
            </>
        )
    )
};

export default CtaCannot;